import { TrendingDown, TrendingUp } from 'lucide-react';
import type { Tradeoff } from '~/lib/feature-modules/types';
import { DIMENSION_LABELS } from '~/lib/utils';

interface Props {
  tradeoffs: Tradeoff[];
}

const DIMENSION_COLORS: Record<string, string> = {
  cost: 'text-orange-600 bg-orange-50 border-orange-200',
  latency: 'text-yellow-600 bg-yellow-50 border-yellow-200',
  complexity: 'text-red-600 bg-red-50 border-red-200',
  scalability: 'text-blue-600 bg-blue-50 border-blue-200',
  ux: 'text-purple-600 bg-purple-50 border-purple-200',
};

export default function TradeoffPanel({ tradeoffs }: Props) {
  if (tradeoffs.length === 0) return null;
  return (
    <div className="space-y-2">
      {tradeoffs.map((t, i) => (
        <div
          key={i}
          className="flex items-start gap-3 p-3 rounded-lg bg-gray-50 border border-gray-100"
        >
          <div className="mt-0.5">
            {t.direction === 'increases' ? (
              <TrendingUp className="h-4 w-4 text-red-500" />
            ) : (
              <TrendingDown className="h-4 w-4 text-emerald-500" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-0.5">
              <span
                className={`inline-block text-xs font-medium border rounded-full px-2 py-0.5 ${DIMENSION_COLORS[t.dimension]}`}
              >
                {DIMENSION_LABELS[t.dimension]}
              </span>
              <span className="text-xs text-gray-500">{t.condition}</span>
            </div>
            <p className="text-sm text-gray-700">{t.impact}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
